import { Type } from "@scalar/typebox";
const REF_DEFINITIONS = {
  ComponentsObject: "ComponentsObject",
  SecurityRequirementObject: "SecurityRequirementObject",
  TagObject: "TagObject",
  CallbackObject: "CallbackObject",
  PathsObject: "PathsObject",
  PathItemObject: "PathItemObject",
  OperationObject: "OperationObject",
  SchemaObject: "SchemaObject",
  EncodingObject: "EncodingObject",
  HeaderObject: "HeaderObject",
  MediaTypeObject: "MediaTypeObject",
  ServerObject: "ServerObject",
  ExternalDocumentationObject: "ExternalDocumentationObject",
  InfoObject: "InfoObject",
  ContactObject: "ContactObject",
  LicenseObject: "LicenseObject",
  ResponseObject: "ResponseObject",
  ResponsesObject: "ResponsesObject",
  ParameterObject: "ParameterObject",
  ExampleObject: "ExampleObject",
  RequestBodyObject: "RequestBodyObject",
  SecuritySchemeObject: "SecuritySchemeObject",
  LinkObject: "LinkObject",
  XMLObject: "XMLObject",
  DiscriminatorObject: "DiscriminatorObject",
  OAuthFlowsObject: "OAuthFlowsObject",
  ServerVariableObject: "ServerVariableObject"
};
const ComponentsObjectRef = Type.Ref(REF_DEFINITIONS.ComponentsObject);
const SecurityRequirementObjectRef = Type.Ref(REF_DEFINITIONS.SecurityRequirementObject);
const TagObjectRef = Type.Ref(REF_DEFINITIONS.TagObject);
const CallbackObjectRef = Type.Ref(REF_DEFINITIONS.CallbackObject);
const PathItemObjectRef = Type.Ref(REF_DEFINITIONS.PathItemObject);
const PathsObjectRef = Type.Ref(REF_DEFINITIONS.PathsObject);
const OperationObjectRef = Type.Ref(REF_DEFINITIONS.OperationObject);
const SchemaObjectRef = Type.Ref(REF_DEFINITIONS.SchemaObject);
const EncodingObjectRef = Type.Ref(REF_DEFINITIONS.EncodingObject);
const HeaderObjectRef = Type.Ref(REF_DEFINITIONS.HeaderObject);
const MediaTypeObjectRef = Type.Ref(REF_DEFINITIONS.MediaTypeObject);
const ServerObjectRef = Type.Ref(REF_DEFINITIONS.ServerObject);
const ExternalDocumentationObjectRef = Type.Ref(REF_DEFINITIONS.ExternalDocumentationObject);
const InfoObjectRef = Type.Ref(REF_DEFINITIONS.InfoObject);
const ContactObjectRef = Type.Ref(REF_DEFINITIONS.ContactObject);
const LicenseObjectRef = Type.Ref(REF_DEFINITIONS.LicenseObject);
const ResponseObjectRef = Type.Ref(REF_DEFINITIONS.ResponseObject);
const ResponsesObjectRef = Type.Ref(REF_DEFINITIONS.ResponsesObject);
const ParameterObjectRef = Type.Ref(REF_DEFINITIONS.ParameterObject);
const ExampleObjectRef = Type.Ref(REF_DEFINITIONS.ExampleObject);
const RequestBodyObjectRef = Type.Ref(REF_DEFINITIONS.RequestBodyObject);
const SecuritySchemeObjectRef = Type.Ref(REF_DEFINITIONS.SecuritySchemeObject);
const LinkObjectRef = Type.Ref(REF_DEFINITIONS.LinkObject);
const XMLObjectRef = Type.Ref(REF_DEFINITIONS.XMLObject);
const DiscriminatorObjectRef = Type.Ref(REF_DEFINITIONS.DiscriminatorObject);
const OAuthFlowsObjectRef = Type.Ref(REF_DEFINITIONS.OAuthFlowsObject);
const ServerVariableObjectRef = Type.Ref(REF_DEFINITIONS.ServerVariableObject);
export {
  CallbackObjectRef,
  ComponentsObjectRef,
  ContactObjectRef,
  DiscriminatorObjectRef,
  EncodingObjectRef,
  ExampleObjectRef,
  ExternalDocumentationObjectRef,
  HeaderObjectRef,
  InfoObjectRef,
  LicenseObjectRef,
  LinkObjectRef,
  MediaTypeObjectRef,
  OAuthFlowsObjectRef,
  OperationObjectRef,
  ParameterObjectRef,
  PathItemObjectRef,
  PathsObjectRef,
  REF_DEFINITIONS,
  RequestBodyObjectRef,
  ResponseObjectRef,
  ResponsesObjectRef,
  SchemaObjectRef,
  SecurityRequirementObjectRef,
  SecuritySchemeObjectRef,
  ServerObjectRef,
  ServerVariableObjectRef,
  TagObjectRef,
  XMLObjectRef
};
//# sourceMappingURL=ref-definitions.js.map
